import { gql, useQuery } from '@apollo/client';

export function useSubSurfacesCount(id: string) {
  const query = gql`
    query subSurfacesCount($surface: ID!) {
      subSurfacesCount(surface: $surface) {
        data
        error
        success
      }
    }
  `;

  const { data } = useQuery(query, {
    variables: { surface: id },
    fetchPolicy: 'network-only',
  });

  return data?.subSurfacesCount?.data ?? 0;
}
